<template>
  <div class="list-project">
    <v-container v-if="loadding">
      <v-row justify="center" align="center">
        <v-col>
          <center>
            <h3>กำลังโหลดข้อมูล</h3>
            <p></p>
            <v-progress-circular
              :size="70"
              :width="5"
              color="success"
              indeterminate
            ></v-progress-circular>
          </center>
        </v-col>
      </v-row>
    </v-container>
    <v-tabs v-model="tabs" v-else grow>
      <v-tabs-slider color="rgb(255, 0, 0, 0)"></v-tabs-slider>
      <v-tab
        :style="
          tabs === 0
            ? 'background: linear-gradient(to left, #065d31 12%, #19a294 100%); color:white; border: 0px solid black;'
            : 'background-color: #ffffff; color:black; border: 0px solid black;'
        "
      >
        <b style="font-size: 16px">ประกาศเชิญชวน</b>
      </v-tab>
      <v-tab
        :style="
          tabs === 1
            ? 'background: linear-gradient(to left, #062e5d 12%, #529ff8 100%); color:white; border: 0px solid black;'
            : 'background-color: #ffffff; color:black; border: 0px solid black;'
        "
      >
        <b style="font-size: 16px">ประกาศร่าง ToR</b>
      </v-tab>
      <v-tab-item>
        <br />
        <v-lazy
          v-model="isActive"
          :options="{
            threshold: 0.5,
          }"
          min-height="100"
          transition="fade-transition"
        >
          <div v-if="sizeInvite !== 0">
            <v-btn
              small
              v-show="fab"
              dark
              fixed
              bottom
              right
              @click="toTop()"
              style="
                color: black;
                background-color: rgb(213, 213, 213, 0.6);
                z-index: 99;
                padding: 5px;
              "
            >
              <v-icon>mdi-chevron-double-up</v-icon>เลื่อนขึ้น
            </v-btn>
            <v-layout v-for="(data, i) in datalists" :key="i">
              <v-flex
                xs12
                sm6
                offset-sm3
                class="mb-4"
                v-if="data.announcement_type === 'invite'"
              >
                <v-card style="border-radius: 10px">
                  <v-container
                    fluid
                    :style="
                      data.announcement_type === 'tor'
                        ? 'background: linear-gradient(to left, #062e5d 12%, #529ff8 100%);'
                        : 'background: linear-gradient(to left, #065d31 12%, #19a294 100%);'
                    "
                  >
                    <v-layout>
                      <v-flex xs12 align-self-center>
                        <center>
                          <p style="font-size: 30px; color: white" class="mb-2">
                            {{ data.name_th }}
                          </p>
                          <span
                            v-if="data.announcement_type === 'tor'"
                            style="color: white; font-size: 20px"
                            ><p>ประกาศร่าง ToR</p></span
                          >
                          <span v-else style="color: white; font-size: 20px"
                            >ประกาศเชิญชวน</span
                          >
                        </center>
                      </v-flex>
                    </v-layout>
                  </v-container>
                  <v-card-title primary-title class="mb-3 pb-2">
                    <div>
                      <p
                        class="mb-0"
                        style="
                          color: #3e950c;
                          font-size: 20px;
                          font-weight: bold;
                        "
                      >
                        {{ data.institution.trim() }}
                      </p>
                      <p
                        class="mb-0"
                        style="
                          color: #6e6e6e;
                          font-size: 14px;
                          font-weight: bold;
                        "
                      >
                        {{ data.project_code.trim() }}
                      </p>
                    </div>
                  </v-card-title>
                  <v-card-subtitle primary-title>
                    <div>
                      <div class="mb-1">
                        <span class="ml-5"></span>{{ data.project_name }}
                      </div>
                      <div>
                        <a :href="data.download_link" target="_blank"
                          ><u>เอกสารจัดซื้อจัดจ้าง [คลิก]</u></a
                        >
                      </div>
                    </div>
                  </v-card-subtitle>
                  <v-card-title
                    primary-title
                    style="margin: auto"
                    class="pt-0 pb-4"
                  >
                    <div style="margin: auto">
                      <p
                        style="
                          color: #dc8006;
                          font-size: 24px;
                          font-weight: bold;
                          margin: auto;
                        "
                      >
                        {{
                          data.middle_price
                            .toString()
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        }}
                        บาท
                      </p>
                    </div>
                    <v-spacer></v-spacer>
                    <ShareNetwork
                      network="line"
                      :url="data.url"
                      title=""
                      description=""
                      quote=""
                      hashtags=""
                    >
                      <v-btn color="green" fab small>
                        <v-icon small color="#ffffff">mdi-share-variant</v-icon>
                      </v-btn>
                    </ShareNetwork>
                  </v-card-title>
                  <v-divider v-if="!data.show_status"></v-divider>
                  <v-card-actions class="pt-2">
                    <v-spacer></v-spacer>
                    <v-btn
                      @click="data.show_status = !data.show_status"
                      text
                      class="ma-2"
                    >
                      เพิ่มเติมคลิก
                      <v-icon>{{
                        data.show_status ? "mdi-chevron-up" : "mdi-chevron-down"
                      }}</v-icon>
                    </v-btn>
                  </v-card-actions>
                  <v-expand-transition>
                    <div v-show="data.show_status">
                      <v-divider></v-divider>
                      <v-card-text>
                        <v-container>
                          <v-row
                            v-if="
                              data.announcement_type === 'invite' &&
                              data.induce_date !== null
                            "
                          >
                            <b
                              >วันที่ประกาศเชิญชวน: <span class="ml-2"></span
                            ></b>
                            {{ data.induce_date.replace(/-/g, " ") }}
                          </v-row>
                          <v-row v-if="data.announcement_type === 'invite'">
                            <b
                              >วันที่ยื่นเสนอราคา: <span class="ml-2"></span
                            ></b>
                            <span v-if="data.submission_date !== null">{{ data.submission_date.replace(/-/g, " ") }}</span>
                            <span v-else>-</span>
                          </v-row>
                          <v-row v-if="data.announcement_type === 'tor'">
                            <b>วันที่เริ่มประกาศ: <span class="ml-2"></span></b>
                            {{ data.tor_date_start.replace(/-/g, " ") }}
                          </v-row>
                          <v-row v-if="data.announcement_type === 'tor'">
                            <b
                              >วันที่สิ้นสุดประกาศ: <span class="ml-2"></span
                            ></b>
                            {{ data.tor_date_end.replace(/-/g, " ") }}
                          </v-row>
                          <v-row>
                            <b>งบประมาณโครงการ: <span class="ml-2"></span></b>
                            {{
                              data.expenditure
                                .toString()
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                            }}
                            บาท
                          </v-row>
                          <v-row
                            v-if="
                              data.announcement_type === 'tor' &&
                              data.same_price !== null
                            "
                          >
                            <b
                              >มูลค่างานประเภทเดียวกัน:
                              <span class="ml-2"></span
                            ></b>
                            {{
                              data.same_price
                                .toString()
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                            }}
                            บาท
                          </v-row>
                          <v-row
                            ><b>คุณสมบัติพิเศษ: <span class="ml-2"></span></b>
                            {{ data.special_features }}</v-row
                          >
                          <v-row v-if="data.latitude !== null">
                            <b>ตำเเหน่งหน้างาน: <span class="ml-2"></span></b>
                            <a
                              style=""
                              @click="
                                changePosition(data.latitude, data.longitude)
                              "
                              ><u>คลิกเพื่อเปิดเเผนที่</u></a
                            >
                          </v-row>
                        </v-container>
                      </v-card-text>
                    </div>
                  </v-expand-transition>
                </v-card>
              </v-flex>
            </v-layout>
          </div>
          <div v-else>
            <center><p>พบประกาศเชิญชวนจำนวน 0 รายการ</p></center>
          </div>
        </v-lazy>
      </v-tab-item>
      <v-tab-item>
        <br />
        <v-lazy
          v-model="isActive"
          :options="{
            threshold: 0.5,
          }"
          min-height="100"
          transition="fade-transition"
        >
          <div v-if="sizeToR !== 0">
            <v-btn
              small
              v-show="fab"
              dark
              fixed
              bottom
              right
              @click="toTop()"
              style="
                color: black;
                background-color: rgb(213, 213, 213, 0.6);
                z-index: 99;
                padding: 5px;
              "
            >
              <v-icon>mdi-chevron-double-up</v-icon>เลื่อนขึ้น
            </v-btn>
            <v-layout v-for="(data, i) in datalists" :key="i">
              <v-flex
                xs12
                sm6
                offset-sm3
                class="mb-4"
                v-if="data.announcement_type === 'tor'"
              >
                <v-card style="border-radius: 10px">
                  <v-container
                    fluid
                    :style="
                      data.announcement_type === 'tor'
                        ? 'background: linear-gradient(to left, #062e5d 12%, #529ff8 100%);'
                        : 'background: linear-gradient(to left, #065d31 12%, #19a294 100%);'
                    "
                  >
                    <v-layout>
                      <v-flex xs12 align-self-center>
                        <center>
                          <p style="font-size: 30px; color: white" class="mb-2">
                            {{ data.name_th }}
                          </p>
                          <span
                            v-if="data.announcement_type === 'tor'"
                            style="color: white; font-size: 20px"
                            ><p>ประกาศร่าง ToR</p></span
                          >
                          <span v-else style="color: white; font-size: 20px"
                            >ประกาศเชิญชวน</span
                          >
                        </center>
                      </v-flex>
                    </v-layout>
                  </v-container>
                  <v-card-title primary-title class="mb-3 pb-2">
                    <div>
                      <p
                        class="mb-0"
                        style="
                          color: #3e950c;
                          font-size: 20px;
                          font-weight: bold;
                        "
                      >
                        {{ data.institution.trim() }}
                      </p>
                      <p
                        class="mb-0"
                        style="
                          color: #6e6e6e;
                          font-size: 14px;
                          font-weight: bold;
                        "
                      >
                        {{ data.project_code.trim() }}
                      </p>
                    </div>
                  </v-card-title>
                  <v-card-subtitle primary-title>
                    <div>
                      <div class="mb-1">
                        <span class="ml-5"></span>{{ data.project_name }}
                      </div>
                      <div>
                        <a :href="data.download_link" target="_blank"
                          ><u>เอกสารจัดซื้อจัดจ้าง [คลิก]</u></a
                        >
                      </div>
                    </div>
                  </v-card-subtitle>
                  <v-card-title
                    primary-title
                    style="margin: auto"
                    class="pt-0 pb-4"
                  >
                    <div style="margin: auto">
                      <p
                        style="
                          color: #dc8006;
                          font-size: 24px;
                          font-weight: bold;
                          margin: auto;
                        "
                      >
                        {{
                          data.middle_price
                            .toString()
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        }}
                        บาท
                      </p>
                    </div>
                    <v-spacer></v-spacer>
                    <ShareNetwork
                      network="line"
                      :url="data.url"
                      title=""
                      description=""
                      quote=""
                      hashtags=""
                    >
                      <v-btn color="green" fab small>
                        <v-icon small color="#ffffff">mdi-share-variant</v-icon>
                      </v-btn>
                    </ShareNetwork>
                  </v-card-title>
                  <v-divider v-if="!data.show_status"></v-divider>
                  <v-card-actions class="pt-2">
                    <v-spacer></v-spacer>
                    <v-btn
                      @click="data.show_status = !data.show_status"
                      text
                      class="ma-2"
                    >
                      เพิ่มเติมคลิก
                      <v-icon>{{
                        data.show_status ? "mdi-chevron-up" : "mdi-chevron-down"
                      }}</v-icon>
                    </v-btn>
                  </v-card-actions>
                  <v-expand-transition>
                    <div v-show="data.show_status">
                      <v-divider></v-divider>
                      <v-card-text>
                        <v-container>
                          <v-row
                            v-if="
                              data.announcement_type === 'invite' &&
                              data.induce_date !== null
                            "
                          >
                            <b
                              >วันที่ประกาศเชิญชวน: <span class="ml-2"></span
                            ></b>
                            {{ data.induce_date.replace(/-/g, " ") }}
                          </v-row>
                          <v-row v-if="data.announcement_type === 'invite'">
                            <b
                              >วันที่ยื่นเสนอราคา: <span class="ml-2"></span
                            ></b>
                            {{ data.submission_date.replace(/-/g, " ") }}
                          </v-row>
                          <v-row v-if="data.announcement_type === 'tor'">
                            <b>วันที่เริ่มประกาศ: <span class="ml-2"></span></b>
                            {{data.tor_date_start}}
                          </v-row>
                          <v-row v-if="data.announcement_type === 'tor'">
                            <b
                              >วันที่สิ้นสุดประกาศ: <span class="ml-2"></span
                            ></b>
                           {{ data.tor_date_end }}
                          </v-row>
                          <v-row>
                            <b>งบประมาณโครงการ: <span class="ml-2"></span></b>
                            {{
                              data.expenditure
                                .toString()
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                            }}
                            บาท
                          </v-row>
                          <v-row
                            v-if="
                              data.announcement_type === 'tor' &&
                              data.same_price !== null
                            "
                          >
                            <b
                              >มูลค่างานประเภทเดียวกัน:
                              <span class="ml-2"></span
                            ></b>
                            {{
                              data.same_price
                                .toString()
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                            }}
                            บาท
                          </v-row>
                          <v-row
                            ><b>คุณสมบัติพิเศษ: <span class="ml-2"></span></b>
                            {{ data.special_features }}</v-row
                          >
                          <v-row v-if="data.latitude !== null">
                            <b>ตำเเหน่งหน้างาน: <span class="ml-2"></span></b>
                            <a
                              style=""
                              @click="
                                changePosition(data.latitude, data.longitude)
                              "
                              ><u>คลิกเพื่อเปิดเเผนที่</u></a
                            >
                          </v-row>
                        </v-container>
                      </v-card-text>
                    </div>
                  </v-expand-transition>
                </v-card>
              </v-flex>
            </v-layout>
          </div>
          <div v-else>
            <center><p>พบประกาศร่าง ToR จำนวน 0 รายการ</p></center>
          </div>
        </v-lazy>
      </v-tab-item>
    </v-tabs>
  </div>
</template>

<script>
export default {
  name: "listproject",
  data: () => ({
    loadding: true,
    datalists: [],
    isActive: false,
    tabs: null,
    fab: true,
    sizeInvite: 0,
    sizeToR: 0,
  }),
  mounted() {
 this.$axios
      .post(this.api + "/checkversion", { version: this.version.split(" ")[3] })
      .then((res) => {
        if (!((res.data.response[0].last_version === this.version.split(" ")[3]))) {
        setTimeout(() => (location.reload()), 2000);
        } else {
    this.$axios
      .post(this.api + "/get/viewdetaildata", {
        head_id: this.$route.params.id.split("_")[0],
        job_type_id_tor: this.$route.params.id.split("_")[2],
        token_id: this.$route.params.id.split("_")[1],
      })
      .then((res) => {
        if (res.data.status) {
          this.loadding = false;
          this.datalists = res.data.response;
          for (let index = 0; index < this.datalists.length; index++) {
            if (this.datalists[index].announcement_type === "tor") {
              this.sizeToR++;
            } else {
              this.sizeInvite++;
            }
          }
        } 
      });
        }
         });
  },
  methods: {
    toTop() {
      this.$vuetify.goTo(0);
    },
    changePosition(latitude, longitude) {
      window.open(
        "https://www.google.co.th/maps/place/" + latitude + "," + longitude,
        "_blank"
      );
    },
  },
};
</script>

<style>
.list-project {
  margin: 3% !important;
}
.bg {
  background-color: red;
}
</style>
